<template>
    <v-flex
        md12
        class="px-12 pb-12"
    >
        <PageHeader
            :breadcrumbs="breadcrumbs"
            :title="$t('page.learn_goal_control_new.title')"
            back
        />
        <v-row>
            <v-col cols="12">
                <LearnGoalControlForm
                    :data="data"
                    :raw-data="rawData"
                    :errors="formErrors"
                    :save-function="saveObject"
                    :discard-function="resetObject"
                />
            </v-col>
        </v-row>
    </v-flex>
</template>

<script>

import PageHeader from '@/components/common/PageHeader';
import LearnGoalControlForm from '@/components/learnGoalControl/Form/LearnGoalControlForm';
import LearnGoalControlProxy from '@/proxies/LearnGoalControlProxy';
import LearnGoalControlMixin from '@/mixins/learnGoalControl';
import { StandBy, SuccessSnackbar } from '@/app-events.js';

export default {
    name: 'LearnGoalControlNew',
    mixins: [ LearnGoalControlMixin ],
    components: {
        PageHeader,
        LearnGoalControlForm,
    },
    data() {
        return {
            breadcrumbs: [
                {
                    text: this.$t('page.home.title'),
                    exact: true,
                    to: { name: 'home' },
                },
                {
                    text: this.$t('page.learn_goal_control.title'),
                    exact: true,
                    to: { name: 'learn_goal_control' },
                },
                {
                    text: this.$t('general.new'),
                    disabled: true,
                },
            ],
            data: {},
            rawData: {},
        };
    },
    methods: {
        saveObject() {
            if (JSON.stringify(this.data) === JSON.stringify(this.rawData)) {
                return;
            }
            this.$eventBus.dispatch(new StandBy(true));
            new LearnGoalControlProxy().new(this.prepareFormData(this.data)).then(({ data }) => {
                this.$eventBus.dispatch(new StandBy(false));
                this.$eventBus.dispatch(new SuccessSnackbar(this.$t('learn_goal_control.actions.created')));
                this.$router.push({ name: 'learn_goal_control_detail', params: { id: data.data.id } });
            }).catch(({ data }) => {
                this.processErrors(data);
                this.$eventBus.dispatch(new StandBy(false));
            });
        }
    },
};
</script>
